const it_IT = {
  "colorpicker.opacity-input": "Opacità",
  "datepicker.clear-date": "Annulla data",
  "datepicker.next-month": "Il prossimo mese",
  "datepicker.open-calendar": "Calendario aperto",
  "datepicker.previous-month": "Il mese scorso",
  "input.clear": "Ingresso chiaro",
  "input.hide-password": "Nascondi password",
  "input.show-password": "Mostra password",
  "modal.close": "Chiudi",
  "multiselectchips.add-value": "Aggiungi ‘{value}’",
  "multiselectchips.remove-all": "Rimuovi tutti",
  "pagination.next-page": "Pagina seguente",
  "pagination.previous-page": "Pagina precedente"
};
export {
  it_IT as default
};
//# sourceMappingURL=it_IT.json.js.map
